import React from 'react';
import { useSelector } from 'react-redux';

import { Icon, Tag } from '@uncinc/uncinc-react-kitchen-sink';
import type { Langcodes, ReferenceField } from '@uncinc/react-drupal-core/types';

import useBubble from '../../../helpers/useBubble';
import { TaxonomyTheme } from '../../../types/uncinc_profile/taxonomy';

interface ThemeTagItemProps {
  theme: (TaxonomyTheme | ReferenceField<TaxonomyTheme>);
}

const ThemeTagItem: React.FC<ThemeTagItemProps> = ({
  theme,
}) => {
  const language = useSelector<Immutable.Map<any, any>>((state) => state.getIn(['ui', 'language']));
  // Determine if we're dealing with an entity or a direct structure
  const themeData = ('entity' in theme) ? theme.entity : theme;

  const {
    BubbleComponent,
    parentRef,
    onEnter,
    onLeave,
  } = useBubble();

  const name = themeData.name?.[0]?.value || themeData.name;
  const link = themeData.field_link?.[0]?.alias ||
    themeData.field_link?.[0]?.uri || themeData.paths[language as Langcodes];

  return (
    <div
      className="ThemeTags__item"
      ref={parentRef}
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
    >
      <Tag
        name={(
          <>
            <span className={link && 'has_link'}>
              <span className="Tag__name__title">{name}</span>
              <BubbleComponent />
            </span>
            {link && (
              <Icon name="chevron_right" />
            )}
          </>
        )}
        link={link}
        target="_self"
      />
    </div>
  );
};

export default ThemeTagItem;
